import React, {useState} from 'react';

export const QuestionTextLine = ({question, preAnswer, response}) => {

    return <div className={"QuestionElement QuestionTextLine"}>
        <div className={"Question"}>{ question }</div>
        <input className={"TextInput"} type={"text"} defaultValue={preAnswer} onChange={ value => response(value.target.value) } />
    </div>
}